export enum AnalyticsOutput {
  BenchAnalysis = 'Bench Analysis - Toe & Crest',
  HaulRoadGradient = 'Haul Road Gradient',
  HaulRoadWidth = 'Haul Road Width',
  DrainageAnalytics = 'Drainage Analytics',
  SlopeStability = 'Slope Stability',
  LandUseLandCover = 'Land Use and Land Cover',
  SuperElevation = 'Super Elevation',
}
